import { AppSurface } from "@shared/components/Surface";

import { T } from "@/components/i18n";
import { Heading } from "@/components/study/Heading";
import { StudyGenericHelp } from "@/components/help/StudyHelp";

import { CircleMinus } from "lucide-react";

export default function StudyHomePage() {
  return (
    <main className="w-full flex-1 flex flex-col items-center py-8 px-6">
      <div className="w-full max-w-2xl my-auto">
        <Heading />
        <AppSurface>
          <h2 className="text-lg font-medium flex items-center gap-x-1.5 mb-4 text-amber-500">
            <CircleMinus size={20} strokeWidth={3} className="-mt-px" />
            <T i18nKey="page.studyHome.status" />
          </h2>
          <p className="text-gray-700 dark:text-neutral-300">
            <T i18nKey="page.studyHome.alert" />
          </p>
          <div className="mt-6 pt-6 border-t border-neutral-200 dark:border-neutral-800">
            <StudyGenericHelp />
          </div>
        </AppSurface>
      </div>
    </main>
  );
}
